import React from "react";
import { Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CommonPage from "../NCLLayout";
// QB Admin
//Question Bank
import QuestionBank from "../../QBAdmin/QuestionBank";
import Scenario from "../../QBAdmin/QuestionBank/MathScenario/ScenarioList";
import AddEditScenario from "../../QBAdmin/QuestionBank/MathScenario/AddEditScenario";
import ScenarioQuestions from "../../QBAdmin/QuestionBank/MathScienceQuestions/AddQuestions/ScenarioQuestions";
import AddUpdateQuestions from "../../QBAdmin/QuestionBank/MathScienceQuestions/AddQuestions/AddUpdateQuestions";
import DirectQuestions from "../../QBAdmin/QuestionBank/MathsDirectQuestions/DirectQuestions";
import PreviewQuestion from "../../QBAdmin/QuestionBank/Preview";
import InputBasedQuestions from "../../QBAdmin/QuestionBank/MathsIBQuestions/IBQuestions";
import CloneAddQuestion from "../../QBAdmin/QuestionBank/MathScienceQuestions/AddQuestions/CloneAddQuestion";
// English QB Admin
import EnglishQB from "../../QBAdmin/QuestionBank/English";
import EScenario from "../../QBAdmin/QuestionBank/English/EnglishScenario/EScenarioList";
import EDirectQuestions from "../../QBAdmin/QuestionBank/English/DirectQuestions";
import EInputBasedQuestions from "../../QBAdmin/QuestionBank/English/IBQuestions";
import EAddEditScenario from "../../QBAdmin/QuestionBank/English/EnglishScenario/AddEditEScenario";
import ScenarioEnglishQuestions from "../../QBAdmin/QuestionBank/English/EnglishScenario/ScenarioEnglishQuestions";
import AddUpdatEngQuestions from "../../QBAdmin/QuestionBank/English/AddUpdatEnglishQuestions";
import EnglishFilters from "../../QBAdmin/QuestionBank/English/QBEnglishFilters/EnglishFilters";
// Hindi QB Admin
import HindiQB from "../../QBAdmin/QuestionBank/Hindi";
import HScenario from "../../QBAdmin/QuestionBank/Hindi/HindiScenario/HScenarioList";
import ScenarioHindiQuestions from "../../QBAdmin/QuestionBank/Hindi/HindiScenario/ScenarioHindiQuestions";
import HDirectQuestions from "../../QBAdmin/QuestionBank/Hindi/HindiDirectQuestions";
import HInputBasedQuestions from "../../QBAdmin/QuestionBank/Hindi/IBQuestions";
import HAddEditScenario from "../../QBAdmin/QuestionBank/Hindi/HindiScenario/AddEditHScenario";
import AddUpdatHindiQuestions from "../../QBAdmin/QuestionBank/Hindi/AddUpdatHindiQuestions";
import QBVerify from "../../QBAdmin/OverallDashboard/QBVerifyStatus";

import QuestionStatus from "../../QBAdmin/QuestionStatus";
import Qstatus from "../../QBAdmin/QuestionStatus/QStatus";

import FilterSQ from "../../QBAdmin/QuestionBank/FilterScenarioQuestions/FilterSQ";
import QBDashboard from "../../QBAdmin/OverallDashboard/QBDashboard";
import OverallDashboard from "../../QBAdmin/OverallDashboard";

import ProgressTracker from "../../QBAdmin/ProgressTracker";
import PTracker from "../../QBAdmin/ProgressTracker/PTracker";
import ProgressDrillDown from "../../QBAdmin/ProgressTracker/ProgressDrillDown";

import ReviewQuestions from "../../QBAdmin/ReviewQuestions/ReviewQuestions";

import Rmaterial from "../../QBAdmin/QuestionBank/Remediation";
// Below are QbScience Filters pages
import ScienceFilters from "../../QBAdmin/QuestionBank/FilterScience/Sciencefilters";

// Below is langugae translater page
import TranslateScenario from "../../QBAdmin/QuestionBank/MathScenario/TranslateScenario";
import TranslateQuestion from "../../QBAdmin/QuestionBank/MathScienceQuestions/AddQuestions/TranslateQuestion";
import QBAQuestionStatusTrack from "../../QBAdmin/QuestionStatusTrack/QuestionStatusTrack";
const QBAdminRoutes = (items,LoginDetails) => {
    // const items = useSelector((state) => state.userDetailsData.LoginDetails.userTypeId);
    // const LoginDetails = useSelector((state) => state.userDetailsData.LoginDetails);
    return (
        <>
            <Route path="/QBAdmin" element={!!items ? <CommonPage /> : <Navigate replace to="/login" />} >
                {LoginDetails?.subjectId === "3" ? (
                    <Route path="/QBAdmin/QuestionBank" element={<EnglishQB />}>
                        <Route index element={<EScenario />} />
                        <Route path="DirectQuestions" element={<EDirectQuestions />} />
                        <Route path="InputBasedQuestions" element={<EInputBasedQuestions />} />
                        <Route path="AddEditScenario" element={<EAddEditScenario />} />
                        <Route path="AddUpdateQuestions" element={<AddUpdatEngQuestions />} />
                        <Route path="ScenarioQuestions" element={<ScenarioEnglishQuestions />} />
                        <Route path="FilterScenarioQuestions" element={<FilterSQ />} />
                        <Route path="Remidation" element={<Rmaterial />} />

                        <Route path="EnglishFilter" element={<EnglishFilters />} />
                    </Route>
                ) : 
                (LoginDetails?.subjectId === "4" || LoginDetails?.subjectId === "5") ? (
                    <Route path="/QBAdmin/QuestionBank" element={<HindiQB />}>
                         <Route index element={<HScenario />} />
                        <Route path="DirectQuestions" element={<HDirectQuestions />} />
                        <Route path="InputBasedQuestions" element={<HInputBasedQuestions />} />
                        <Route path="AddEditScenario" element={<HAddEditScenario />} />
                        <Route path="AddUpdateQuestions" element={<AddUpdatHindiQuestions />} />
                        <Route path="ScenarioQuestions" element={<ScenarioHindiQuestions />} />
                       {/* <Route path="FilterScenarioQuestions" element={<FilterSQ />} />
                        <Route path="Remidation" element={<Rmaterial />} /> */}

                        {/* <Route path="EnglishFilter" element={<EnglishFilters />} /> */}
                    </Route>
                ):
                
                (
                    <Route path="/QBAdmin/QuestionBank" element={<QuestionBank />} >
                        <Route index element={<Scenario />} />
                        <Route path="ScenarioQuestions" element={<ScenarioQuestions />} />
                        <Route path="DirectQuestions" element={<DirectQuestions />} />
                        <Route path="InputBasedQuestions" element={<InputBasedQuestions />} />
                        <Route path="AddEditScenario"
                            element={LoginDetails?.subjectId === "3" ? (<EAddEditScenario />) : (<AddEditScenario />)} />
                        <Route path="/QBAdmin/QuestionBank/AddUpdateQuestions"
                            element={LoginDetails?.subjectId === "3" ? (<AddUpdatEngQuestions />) : (<AddUpdateQuestions />)} />
                        <Route path="CloneAddQuestion" element={<CloneAddQuestion />} />
                        <Route path="TranslateQuestion" element={<TranslateQuestion />} />
                        <Route path="TranslateScenario" element={<TranslateScenario />} />
                        <Route path="FilterScenarioQuestions" element={<FilterSQ />} />

                        <Route path="Remidation" element={<Rmaterial />} />
                        <Route path="/QBAdmin/QuestionBank/ScienceFilters" element={<ScienceFilters />} ></Route>
                    </Route>
                )}
                <Route path="/QBAdmin/OverallDashboard" element={<OverallDashboard />} >
                    <Route index element={<QBDashboard />} />
                    <Route path="VerificationSTatus" element={<QBVerify />} />
                    <Route path="AddEditScenario"
                        element={LoginDetails?.subjectId === "3" ? (<EAddEditScenario />) : (<AddEditScenario />)} />
                    <Route path="AddUpdateQuestions"
                        element={LoginDetails?.subjectId === "3" ? (<AddUpdatEngQuestions />) : (<AddUpdateQuestions />)} />
                    <Route path="CloneAddQuestion" element={<CloneAddQuestion />} />
                    <Route path="TranslateQuestion" element={<TranslateQuestion />} />
                    <Route path="TranslateScenario" element={<TranslateScenario />} />
                </Route>

                <Route path="/QBAdmin/QuestionStatus" element={<QuestionStatus />}>
                    <Route index element={<Qstatus />} />
                    <Route path="AddEditScenario"
                        element={LoginDetails?.subjectId === "3" ? (<EAddEditScenario />) : (<AddEditScenario />)} />
                    <Route path="AddUpdateQuestions"
                        element={LoginDetails?.subjectId === "3" ? (<AddUpdatEngQuestions />) : (<AddUpdateQuestions />)} />
                    <Route path="CloneAddQuestion" element={<CloneAddQuestion />} />
                </Route>
                <Route path="/QBAdmin/Progresstracker" element={<ProgressTracker />}>
                    <Route index element={<PTracker />} />
                    <Route path="DrillDown" element={<ProgressDrillDown />} />
                    <Route path="AddEditScenario"
                        element={LoginDetails?.subjectId === "3" ? (<EAddEditScenario />) : (<AddEditScenario />)} />
                    <Route path="AddUpdateQuestions"
                        element={LoginDetails?.subjectId === "3" ? (<AddUpdatEngQuestions />) : (<AddUpdateQuestions />)} />
                    <Route path="CloneAddQuestion" element={<CloneAddQuestion />} />
                </Route>
                <Route path="/QBAdmin/ReviewQuestions" element={<OverallDashboard />} >
                    <Route index element={<ReviewQuestions />} />
                    <Route path="AddEditScenario" element={<AddEditScenario />} />
                    <Route path="AddUpdateQuestions" element={<AddUpdatEngQuestions />} />
                    <Route path="CloneAddQuestion" element={<CloneAddQuestion />} />
                </Route>
                <Route path="PreviewQuestion" element={<PreviewQuestion />} />
                 <Route path="QSTrack" element={<QBAQuestionStatusTrack />} />
            </Route>
        </>
    )
}
export default QBAdminRoutes;